import { AgentsStore } from "../agentsTypes";
import { AgentDetailSaveScope, AgentDetailSectionEnum } from "../../agentDetail.model";
import { isScopeDirty } from "./agentDetail.utils";
import {
    EMPTY_HIERARCHY,
    EMPTY_LICENSED_STATES,
    EMPTY_PRODUCTS,
    EMPTY_RESTRICTED_FIELDS,
} from "./agentDetailState";
import { hasPersonalInfoErrors } from "../../components/editAgent/components/mainDetails/components/rightSection/components/personalPanel/personalPanel.constants";
import { hasBusinessInfoErrors } from "../../components/editAgent/components/mainDetails/components/rightSection/components/businessPanel/businessPanel.constants";

export const selectAgentDetail = (state: AgentsStore) => state.detail.data;
export const selectAgentDetailDraft = (state: AgentsStore) => state.detail.draft;
export const selectAgentDetailLoading = (state: AgentsStore) => state.detail.status === "loading";
export const selectAgentDetailSaving = (state: AgentsStore) => state.detail.saveStatus === "saving";
export const selectIsEditMode = (state: AgentsStore) => state.detail.isEditMode;

export const selectIsScopeDirty =
    (scope: AgentDetailSaveScope) =>
    (state: AgentsStore): boolean => {
        const { draft, data } = state.detail;
        if (!draft || !data) return false;
        return isScopeDirty(draft, data, scope);
    };

export const selectRestrictedFields = (state: AgentsStore) =>
    state.detail.data?.restrictedFields ?? EMPTY_RESTRICTED_FIELDS;

export const selectHiddenFields = (state: AgentsStore) =>
    state.detail.data?.hiddenFields ?? EMPTY_RESTRICTED_FIELDS;

export const selectLicensedStates = (state: AgentsStore) =>
    state.detail.data?.contractAndLicensingInformation?.licensedStates ?? EMPTY_LICENSED_STATES;

export const selectDraftLicensedStates = (state: AgentsStore) =>
    state.detail.draft?.contractAndLicensingInformation?.licensedStates ?? EMPTY_LICENSED_STATES;

export const selectProducts = (state: AgentsStore) =>
    state.detail.data?.contractAndLicensingInformation?.agentProductDetails ?? EMPTY_PRODUCTS;

export const selectDraftProducts = (state: AgentsStore) =>
    state.detail.draft?.contractAndLicensingInformation?.agentProductDetails ?? EMPTY_PRODUCTS;

export const selectAgentHierarchy = (state: AgentsStore) =>
    state.detail.data?.contractAndLicensingInformation?.hierarchyInformation ?? EMPTY_HIERARCHY;

export const selectAllStates = (state: AgentsStore) => state.allStates;
export const selectAllStatesLoading = (state: AgentsStore) => state.allStatesLoading;

export const selectPersonalInfoHasErrors = (state: AgentsStore): boolean =>
    hasPersonalInfoErrors(
        state.detail.draft?.personalInformation ?? null,
        state.detail.data?.personalInformation ?? null
    );

export const selectBusinessInfoHasErrors = (state: AgentsStore): boolean =>
    hasBusinessInfoErrors(
        state.detail.draft?.businessInformation ?? null,
        state.detail.data?.businessInformation ?? null,
    );

export const selectHasErrorsByScope = (scope: AgentDetailSaveScope) => (state: AgentsStore): boolean => {
    const personalInfoHasErrors = hasPersonalInfoErrors(
        state.detail.draft?.personalInformation ?? null,
        state.detail.data?.personalInformation ?? null
    );
    const businessInfoHasErrors = hasBusinessInfoErrors(
        state.detail.draft?.businessInformation ?? null,
        state.detail.data?.businessInformation ?? null
    );

    if (scope === "all") {
        return personalInfoHasErrors || businessInfoHasErrors;
    }

    if (scope === AgentDetailSectionEnum.PERSONAL_INFORMATION) {
        return personalInfoHasErrors;
    }

    if (scope === AgentDetailSectionEnum.BUSINESS_INFORMATION) {
        return businessInfoHasErrors;
    }

    return false;
};